export default __webpack_public_path__ + "static/media/sort-desc.6ea72dee.svg";